module.exports = "/assets/data/5baa250d9a9705948bfb874d0ecd8d34-BS3.data.json";